
import card from '~/mixins/card'
import { recapHtml } from '~/util/aep-recommendation'
export default {
    mixins: [card],
    computed: {
        recap () {
            return recapHtml(this.aepPayer)
        },
    },
}
